const vehicleCapacityModel = vm => ({
  title: vm.$gettext('Vehicle Capacity'),
  endpoint: 'sizes',
  shared: 'semi',
  includes: ['vehicle_type_capacity.vehicle_type']
})

export default vehicleCapacityModel
